import { useMemo } from "react";
import { router } from "react-query-kit";
import {
  getPagedRequest,
  getRequest,
  postRequest,
  QueryParams,
  saveRequest,
  useBaseUrl,
  useInvalidate
} from "@services/api/requests.service";
import { ReferenceFormData } from "@src/app/references/ReferenceForm";
import { Reference } from "./reference.types";

export default function useReferenceApi() {
  const baseUrl = useBaseUrl("/references");

  const referenceApi = useMemo(
    () =>
      router("reference", {
        import: router.mutation({
          mutationFn: (year: string) =>
            postRequest(`${baseUrl}/import?year=${year}`, null)
        }),

        page: router.query({
          fetcher: (queryParams: QueryParams) =>
            getPagedRequest<Reference>(baseUrl, queryParams)
        }),

        findByOne: router.query({
          fetcher: (type: string) =>
            getRequest<Reference[]>(`${baseUrl}/${type}`)
        }),

        upsert: router.mutation({
          mutationFn: (data: ReferenceFormData) =>
            saveRequest<Reference>(baseUrl, data)
        })
      }),
    [baseUrl]
  );

  const invalidate = useInvalidate(referenceApi);

  return {
    useImportQuery: referenceApi.import.useMutation,
    useFindByOneQuery: referenceApi.findByOne.useQuery,
    usePageQuery: referenceApi.page.useQuery,
    useSaveMutation: referenceApi.upsert.useMutation,
    invalidate
  };
}
